// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3975) return "static/chunks/3975-54608332da641dfd.js";
	if (chunkId === 7227) return "static/chunks/7227-a88cf04d65baa964.js";
	if (chunkId === 5184) return "static/chunks/5184-efea0908d8bbf534.js";
	if (chunkId === 1950) return "static/chunks/1950-fd95ebd89a4baa41.js";
	if (chunkId === 2408) return "static/chunks/2408-8502fe05b4d14c64.js";
	if (chunkId === 6488) return "static/chunks/6488-78c3fd086ea77b01.js";
	if (chunkId === 5328) return "static/chunks/5328-4477ef6094aac1a7.js";
	if (chunkId === 4652) return "static/chunks/4652-2e63bc151033b042.js";
	if (chunkId === 9469) return "static/chunks/9469-4d2fd32892eaf827.js";
	if (chunkId === 3693) return "static/chunks/3693-fd1af41aeadce107.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"236":"ea3823a4df65b202","1100":"94fcafb1a41bb2dd","1291":"b08c5c870454cf1a","1480":"4229e9624ecd7cfb","1811":"e957e2d15ab28b38","2180":"b9225e68a0fe7d8d","4801":"d3936250faad1561","5982":"6c86c8a33680dddb","7034":"c63cddee7beb3bd4","7636":"f183f913dca6317a","8089":"ba542ccaf8a1df98"}[chunkId] + ".js";
};